import React, { useEffect } from 'react';
import { useVideo } from '../context/VideoContext';
import { useAuth } from '../context/AuthContext';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Container, Row, Col, Button } from 'react-bootstrap';
import VideoCard from './VideoCard';
import DateFilter from './DateFilter';

const VideoList: React.FC = () => {
  const { videos, loading, hasMore, loadVideos, selectedDate } = useVideo();
  const { logout } = useAuth();

  useEffect(() => {
    loadVideos();
  }, []);

  const fetchMoreData = () => {
    loadVideos(selectedDate, true);
  };

  return (
    <Container className="mt-4">
      <Row className="mb-4">
        <Col>
          <h1>Видеоархив</h1>
        </Col>
        <Col xs="auto">
          <Button variant="outline-secondary" onClick={logout}>
            Выйти
          </Button>
        </Col>
      </Row>
      <DateFilter />
      <InfiniteScroll
        dataLength={videos.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Загрузка...</h4>}
        endMessage={<p>Все видео загружены</p>}
      >
        <Row>
          {videos.map((video) => (
            <Col key={video.id} md={4} className="mb-4">
              <VideoCard video={video} />
            </Col>
          ))}
        </Row>
      </InfiniteScroll>
      {loading && videos.length === 0 && <p>Загрузка видео...</p>}
    </Container>
  );
};

export default VideoList;